import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GrowlNotificationSupportedVariant } from '@gaiads/telia-react-component-library';
import { RootState } from '.';

type NotificationType = GrowlNotificationSupportedVariant;

export interface Notification {
  show: boolean;
  text: string;
  type: NotificationType;
}

interface UiState {
  notification: Notification;
}

export const initialNotification: Notification = {
  text: '',
  show: false,
  type: 'success',
};

export const initialUiState: UiState = {
  notification: initialNotification,
};

const ui = createSlice({
  name: 'ui',
  initialState: initialUiState,
  reducers: {
    setNotification: (state, action: PayloadAction<Notification>) => {
      const { show, text, type } = action.payload;
      state.notification.text = text;
      state.notification.show = show;
      state.notification.type = type;
    },
    resetNotification: state => {
      state.notification = initialNotification;
    },
  },
});

export const { setNotification, resetNotification } = ui.actions;

export default ui.reducer;

export const selectNotification = (state: RootState) => state.ui.notification;
